/** Shared visual tokens for ATUTEIN DMS redesign */
export const tokens = {
  ink: '#14261F',
  primary: '#1E5C46',
  primaryStrong: '#174A38',
  primarySoft: '#E7F0EC',
  accent: '#D9A441',
  accentSoft: '#FBF3E2',
  bg: '#F6F8F6',
  surface: '#FFFFFF',
  border: '#E3E8E3',
  muted: '#66736C',
  danger: '#B4442C',
  dangerSoft: '#FBEDE9',
  radius: '10px',
  shadow: '0 1px 2px rgba(20,38,31,.06), 0 4px 14px rgba(20,38,31,.05)',
  fontDisplay: '"Archivo", sans-serif',
  fontBody: '"Inter", "Inter var", sans-serif',
};

export const pageHeadSx = {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: 2,
  mb: 2.75,
  flexWrap: 'wrap',
};

export const pageTitleSx = {
  fontFamily: tokens.fontDisplay,
  fontWeight: 600,
  fontSize: 22,
  letterSpacing: '-0.01em',
  color: tokens.ink,
  lineHeight: 1.25,
};

export const crumbsSx = {
  fontSize: 12,
  color: tokens.muted,
  mb: 0.5,
};

export const surfaceCardSx = {
  bgcolor: tokens.surface,
  border: `1px solid ${tokens.border}`,
  borderRadius: tokens.radius,
  boxShadow: tokens.shadow,
};

export const tableHeadCellSx = {
  fontSize: 11.5,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: tokens.muted,
  fontWeight: 600,
  bgcolor: '#FBFCFB',
  borderBottom: `1px solid ${tokens.border}`,
  py: 1.25,
};

export const statusPillSx = (kind) => {
  const map = {
    active: { bg: tokens.primarySoft, color: tokens.primary },
    pending: { bg: tokens.accentSoft, color: '#8A6415' },
    inactive: { bg: '#EEF1EF', color: tokens.muted },
    danger: { bg: tokens.dangerSoft, color: tokens.danger },
  };
  const s = map[kind] || map.inactive;
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.75,
    px: 1.1,
    py: 0.35,
    borderRadius: 99,
    fontSize: 12,
    fontWeight: 600,
    bgcolor: s.bg,
    color: s.color,
  };
};
